/**
 * Fehler der geworfen wird, wenn beim Verbuchen nicht Ziel und Quelle gesetzt sind.
 */
export class StocksNotSetError extends Error {
    constructor() {
        super('Stocks not set in StockInventoryHelperService');
    }
}